// === ГАЛЕРЕЯ ГРАФИКОВ ===

import { isTourComplete, tourData } from "scripts/ui/tour/tour";
import { apiFetchFolders } from "../api/folder";
import { apiFetchCsvForSector, apiFetchGraphsForSector } from "../api/image";
import { apiFetchSectorsForFolder } from "../api/sector";
import { Detector } from "scripts/classes/detector";
import { drawHeatmap, drawHeatmapFlux } from "./graph/graph";

const galleryBtn            = document.getElementById('gallery-button')      as HTMLButtonElement;
const galleryModal          = document.getElementById('galleryModal')         as HTMLElement;
const galleryCloseBtn       = document.getElementById('gallery-close')        as HTMLButtonElement;
const foldersListContainer  = document.getElementById('foldersListContainer') as HTMLElement;
const graphsContainer       = document.getElementById('graphsContainer')      as HTMLElement;
const foldersLoading        = document.getElementById('foldersLoading')       as HTMLElement;

// --- 1. Открытие / Закрытие модального окна ---

galleryBtn.addEventListener('click', () => {
    galleryModal.style.display = 'block';
    loadFolders();
});

galleryCloseBtn.addEventListener('click', () => {
    galleryModal.style.display = 'none';
});

galleryModal.addEventListener('click', (e) => {
    if (e.target === galleryModal) galleryModal.style.display = 'none';
});

// --- 2. Полноэкранный просмотр ---

function createFullscreenOverlay(title: string): { overlay: HTMLElement; content: HTMLElement } {
    const overlay = document.createElement('div');
    overlay.className = 'fullscreen-overlay';

    const titleEl = document.createElement('div');
    titleEl.className = 'fullscreen-title';
    titleEl.textContent = title;

    const content = document.createElement('div');
    content.className = 'fullscreen-content';

    const closeBtn = document.createElement('button');
    closeBtn.className = 'fullscreen-close';
    closeBtn.innerHTML = '×';

    const close = () => {
        document.body.removeChild(overlay);
        document.removeEventListener('keydown', onKeyDown);
    };

    const onKeyDown = (e: KeyboardEvent) => { if (e.key === 'Escape') close(); };
    document.addEventListener('keydown', onKeyDown);

    closeBtn.addEventListener('click', (e) => { e.stopPropagation(); close(); });
    overlay.addEventListener('click', close);
    content.addEventListener('click', (e) => e.stopPropagation());

    overlay.appendChild(titleEl);
    overlay.appendChild(content);
    overlay.appendChild(closeBtn);
    document.body.appendChild(overlay);

    return { overlay, content };
}

function showFullscreenImage(imageUrl: string, title: string) {
    const { content } = createFullscreenOverlay(title);
    const img = document.createElement('img');
    img.src = imageUrl;
    img.className = 'fullscreen-img';
    content.appendChild(img);
}

function showFullscreenChart(sectorId: string, sectorName: string, type: string, csvText: string) {
    const { overlay, content } = createFullscreenOverlay(sectorName);
    overlay.style.background = '#f5f5f5';
    overlay.querySelector<HTMLElement>('.fullscreen-title')!.style.color = '#333';
    overlay.querySelector<HTMLElement>('.fullscreen-close')!.style.cssText += 'background:rgba(0,0,0,0.15); color:#333;';
    content.classList.add('fullscreen-chart');
    if (type === 'flux') {
        drawHeatmapFlux(sectorId, content, csvText);
    } else {
        drawHeatmap(sectorId, content, csvText);
    }
}

// --- 3. Фабрика карточек ---

function createGraphCard(sectorId: string, sectorName: string, id: string): HTMLElement {
    const card = document.createElement('div');
    card.className = `graph-card graph-for-sector-${sectorId}`;
    card.id = id;
    card.setAttribute('data-parent-sector', sectorId);
    // position: relative гарантируем явно, чтобы кнопка позиционировалась верно
    card.style.position = 'relative';

    const btn = document.createElement('button');
    btn.className = 'graph-fullscreen-btn';
    btn.title = 'На весь экран';
    btn.textContent = '⛶';
    btn.style.cssText = `
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 10;
    `;
    card.appendChild(btn);

    const label = document.createElement('p');
    label.innerHTML = `<strong>${sectorName}</strong>`;
    card.appendChild(label);

    return card;
}

// --- 4. Управление галереей ---

function removeEmptyMessage() {
    graphsContainer.querySelector('.empty-gallery-msg')?.remove();
}

function showEmptyIfNeeded() {
    if (graphsContainer.children.length === 0) {
        graphsContainer.innerHTML = '<div class="empty-gallery-msg">Выберите секторы слева, чтобы увидеть графики</div>';
    }
}

// Функция для покраски чекбокса в красный при ошибке
function markCheckboxAsError(sectorId: string, type: string) {
    let selector = '';
    switch(type) {
        case 'thickness-img':
            selector = `.sector-checkbox-img[data-sector-id="${sectorId}"]`;
            break;
        case 'flux-img':
            selector = `.sector-flux-checkbox-img[data-sector-id="${sectorId}"]`;
            break;
        case 'thickness-csv':
            selector = `.sector-checkbox[data-sector-id="${sectorId}"]`;
            break;
        case 'flux-csv':
            selector = `.sector-flux-checkbox[data-sector-id="${sectorId}"]`;
            break;
    }
    
    const checkbox = document.querySelector(selector) as HTMLInputElement;
    if (checkbox) {
        checkbox.style.accentColor = 'red';
        checkbox.style.filter = 'drop-shadow(0 0 3px red)';
        checkbox.setAttribute('data-error', 'true');
    }
}

// Функция для сброса красного цвета (при успешной загрузке)
function resetCheckboxError(sectorId: string, type: string) {
    let selector = '';
    switch(type) {
        case 'thickness-img':
            selector = `.sector-checkbox-img[data-sector-id="${sectorId}"]`;
            break;
        case 'flux-img':
            selector = `.sector-flux-checkbox-img[data-sector-id="${sectorId}"]`;
            break;
        case 'thickness-csv':
            selector = `.sector-checkbox[data-sector-id="${sectorId}"]`;
            break;
        case 'flux-csv':
            selector = `.sector-flux-checkbox[data-sector-id="${sectorId}"]`;
            break;
    }
    
    const checkbox = document.querySelector(selector) as HTMLInputElement;
    if (checkbox) {
        checkbox.style.accentColor = '';
        checkbox.style.filter = '';
        checkbox.removeAttribute('data-error');
    }
}

// Синхронизация чекбоксов с существующими графиками
function syncCheckboxesWithGraphs() {
    document.querySelectorAll('.db-sector-item').forEach(item => {
        const sectorId = item.getAttribute('data-sector-id');
        if (!sectorId) return;

        const allCheckboxes = item.querySelectorAll('input[type="checkbox"]');
        allCheckboxes.forEach(cb => {
            (cb as HTMLInputElement).style.accentColor = '';
            (cb as HTMLInputElement).style.filter = '';
            (cb as HTMLInputElement).removeAttribute('data-error');
        });
        
        // Проверяем наличие графиков в DOM
        const hasImgThickness = document.getElementById(`${sectorId}-img`) !== null;
        const hasImgFlux = document.getElementById(`${sectorId}-flux-img`) !== null;
        const hasCsvThickness = document.getElementById(`heatmap-thickness-${sectorId}`) !== null;
        const hasCsvFlux = document.getElementById(`heatmap-flux-${sectorId}`) !== null;
        
        // Устанавливаем состояние чекбоксов
        const imgThicknessCheckbox = item.querySelector('.sector-checkbox-img') as HTMLInputElement;
        const imgFluxCheckbox = item.querySelector('.sector-flux-checkbox-img') as HTMLInputElement;
        const csvThicknessCheckbox = item.querySelector('.sector-checkbox') as HTMLInputElement;
        const csvFluxCheckbox = item.querySelector('.sector-flux-checkbox') as HTMLInputElement;
        
        if (imgThicknessCheckbox) imgThicknessCheckbox.checked = hasImgThickness;
        if (imgFluxCheckbox) imgFluxCheckbox.checked = hasImgFlux;
        if (csvThicknessCheckbox) csvThicknessCheckbox.checked = hasCsvThickness;
        if (csvFluxCheckbox) csvFluxCheckbox.checked = hasCsvFlux;
    });
}

function removeGraphsFromGallery(cardId: string) {
    console.log('Удаляем график:', cardId);
    
    // Пробуем найти и удалить карточку по ID
    const cardToRemove = document.getElementById(cardId);
    if (cardToRemove) {
        cardToRemove.remove();
        showEmptyIfNeeded();
        return;
    }
    
    // Если не нашли по ID, пробуем по data-parent-sector
    const sectorId = cardId.split('-')[0];
    const cardsBySector = document.querySelectorAll(`.graph-for-sector-${sectorId}`);
    cardsBySector.forEach(card => card.remove());
    
    showEmptyIfNeeded();
}

async function addImageCard(sectorId: string, sectorName: string, type: string, id: string) {
    removeEmptyMessage();

    const loadingId = `loading-${id}`;
    graphsContainer.insertAdjacentHTML('beforeend',
        `<div id="${loadingId}" class="graph-loading">Загрузка...</div>`
    );

    try {
        const graph = await apiFetchGraphsForSector(sectorId, type);
        document.getElementById(loadingId)?.remove();

        if (!graph || !graph.file_name) {
            throw new Error('Нет данных');
        }

        const link = graph.file_name.replace('csv', 'png');

        // Проверяем загрузку картинки
        const testImg = new Image();
        testImg.onload = () => {
            // Успех - сбрасываем красный
            resetCheckboxError(sectorId, type === 'flux' ? 'flux-img' : 'thickness-img');
            const card = createGraphCard(sectorId, sectorName, id);
            const img = document.createElement('img');
            img.src = link;
            img.alt = `График ${sectorName}`;
            card.insertBefore(img, card.firstChild);

            const openFullscreen = () => showFullscreenImage(link, sectorName);
            card.addEventListener('click', openFullscreen);
            card.querySelector('.graph-fullscreen-btn')!.addEventListener('click', (e) => {
            e.stopPropagation();
            openFullscreen();
        });

        graphsContainer.appendChild(card);
        highlightSectorAndGraphs(sectorId);
        };

        testImg.onerror = () => {
            document.getElementById(loadingId)?.remove();
            markCheckboxAsError(sectorId, type === 'flux' ? 'flux-img' : 'thickness-img');
            showEmptyIfNeeded();
        };
        
        testImg.src = link;

    } catch (err) {
        console.error('Ошибка загрузки графиков:', err);
        const loadingEl = document.getElementById(loadingId);
        if (loadingEl) {
            loadingEl.textContent = 'Не удалось загрузить графики';
            loadingEl.style.color = 'red';
        }
        markCheckboxAsError(sectorId, type === 'flux' ? 'flux-img' : 'thickness-img');
    }
}

async function addCsvCard(sectorId: string, sectorName: string, type: string, id: string) {
    removeEmptyMessage();

    const containerId = `heatmap-${type}-${sectorId}`;
    const card = createGraphCard(sectorId, sectorName, id);
    card.classList.add('graph-interactive');

    const heatmapDiv = document.createElement('div');
    heatmapDiv.id = containerId;
    heatmapDiv.className = 'heatmap-container';
    heatmapDiv.innerHTML = '<div class="graph-loading">Загрузка...</div>';
    card.insertBefore(heatmapDiv, card.firstChild);

    graphsContainer.appendChild(card);

    try {
        const csvFile = await apiFetchCsvForSector(sectorId, type);

        if (!csvFile) {
            heatmapDiv.textContent = 'Нет данных';
            return;
        }

        const csvText = await csvFile.text();
        heatmapDiv.innerHTML = '';

        if (type === 'flux') {
            drawHeatmapFlux(sectorId, heatmapDiv, csvText);
        } else {
            drawHeatmap(sectorId, heatmapDiv, csvText);
        }

        // Успех - сбрасываем красный
        resetCheckboxError(sectorId, type === 'flux' ? 'flux-csv' : 'thickness-csv');

        card.querySelector('.graph-fullscreen-btn')!.addEventListener('click', (e) => {
            e.stopPropagation();
            showFullscreenChart(sectorId, sectorName, type, csvText);
        });

        highlightSectorAndGraphs(sectorId);

    } catch (err) {
        console.error('Ошибка загрузки графиков:', err);
        heatmapDiv.innerHTML = '<div style="color:red;">Не удалось загрузить данные</div>';
        markCheckboxAsError(sectorId, type === 'flux' ? 'flux-csv' : 'thickness-csv');
    }
}

// --- 5. Загрузка папок ---

async function loadFolders() {
    foldersLoading.style.display = 'block';

    try {
        const folders = await apiFetchFolders();
        if (!folders) {
            console.error('Ошибка получения папок');
            return;
        }

        foldersLoading.style.display = 'none';
        foldersListContainer.innerHTML = '';

        const tourFolderId = !isTourComplete() ? tourData.folderId : null;

        folders.forEach(folder => {
            const folderEl = document.createElement('div');
            folderEl.className = 'folder-wrapper';
            folderEl.innerHTML = `
                <div class="folder-header ${folder.id === tourFolderId ? 'tour' : ''}" data-id="${folder.id}">
                    <span class="folder-name">${folder.name}</span>
                    <a href="/image/download/folder/${folder.id}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-download" style="margin-top:auto" viewBox="0 0 16 16">
                          <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
                          <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"/>
                        </svg>
                    </a>
                </div>
                <div class="sectors-list" id="sectors-for-${folder.id}"></div>
            `;
            foldersListContainer.appendChild(folderEl);
        });

        document.querySelectorAll('.folder-header').forEach(header => {
            header.addEventListener('click', async function (this: HTMLElement) {
                const folderWrapper = this.parentElement as HTMLElement;
                const folderId = this.getAttribute('data-id') as string;
                const sectorsContainer = folderWrapper.querySelector('.sectors-list') as HTMLElement;

                const willExpand = !folderWrapper.classList.contains('expanded');
                folderWrapper.classList.toggle('expanded', willExpand);
                this.classList.toggle('expanded', willExpand);

                if (willExpand && sectorsContainer.innerHTML.trim() === '') {
                    sectorsContainer.innerHTML = '<small style="color:#888;">Загрузка...</small>';
                    const detectors = await apiFetchSectorsForFolder(folderId);
                    renderDetectors(sectorsContainer, detectors);
                    syncCheckboxesWithGraphs();
                }
            });
        });
        setTimeout(() => {
            syncCheckboxesWithGraphs();
        }, 100);

    } catch (error) {
        console.error('Ошибка загрузки папок:', error);
        foldersLoading.textContent = 'Не удалось загрузить папки';
    }
}

// --- 6. Рендер секторов ---

function detectorName(detector: Detector): string {
    return detector.name || `Сектор ${detector.id?.substring(0, 8)}`;
}

function renderDetectors(container: HTMLElement, detectors: Detector[]) {
    container.innerHTML = '';

    if (detectors.length === 0) {
        container.innerHTML = '<small style="color:#888;">Нет датчиков</small>';
        return;
    }

    const tourSectorId = !isTourComplete() ? tourData.sectorId : null;

    detectors.forEach(detector => {
        const id   = detector.id ?? '';
        const name = detectorName(detector);
        const tour = detector.id === tourSectorId ? 'tour' : '';

        const item = document.createElement('div');
        item.className = 'db-sector-item';
        item.setAttribute('data-sector-id', id);
        item.innerHTML = `
            <div class="col">
                <label class="sector-label" style="cursor:pointer; flex:1;">${name}</label>
                <div>
                    <input type="checkbox" class="sector-checkbox-img ${tour}" data-sector-id="${id}">
                    <input type="checkbox" class="sector-flux-checkbox-img ${tour}" data-sector-id="${id}">
                    <label>Изображения</label>
                </div>
                <div>
                    <input type="checkbox" class="sector-checkbox ${tour}" data-sector-id="${id}">
                    <input type="checkbox" class="sector-flux-checkbox ${tour}" data-sector-id="${id}">
                    <label>Интерактивные</label>
                </div>
            </div>
        `;
        container.appendChild(item);

        type CheckboxConfig = {
            selector: string;
            cardId: string;
            add: (cardId: string) => Promise<void>;
        };

        const configs: CheckboxConfig[] = [
            { selector: '.sector-checkbox-img',      cardId: `${id}-img`,      add: (c) => addImageCard(id, name, 'thickness', c) },
            { selector: '.sector-flux-checkbox-img', cardId: `${id}-flux-img`, add: (c) => addImageCard(id, name, 'flux', c) },
            { selector: '.sector-checkbox',          cardId: `${id}-csv`,      add: (c) => addCsvCard(id, name, 'thickness', c) },
            { selector: '.sector-flux-checkbox',     cardId: `${id}-flux-csv`, add: (c) => addCsvCard(id, name, 'flux', c) },
        ];

        configs.forEach(({ selector, cardId, add }) => {
            const checkbox = item.querySelector(selector) as HTMLInputElement;
            checkbox.addEventListener('change', async (e) => {
                if ((e.target as HTMLInputElement).checked) {
                    await add(cardId);
                } else {
                    removeGraphsFromGallery(cardId);
                }
            });
        });

        item.querySelector('.sector-label')!.addEventListener('click', (e) => {
            e.preventDefault();
            highlightSectorAndGraphs(id);
        });
    });
    syncCheckboxesWithGraphs();
}

// --- 7. Подсветка ---

function highlightSectorAndGraphs(targetSectorId: string) {
    document.querySelectorAll('.db-sector-item').forEach(item => item.classList.remove('highlighted'));
    document.querySelectorAll('.graph-card').forEach(card => card.classList.remove('highlighted-graph'));

    document.querySelector(`.db-sector-item[data-sector-id="${targetSectorId}"]`)
        ?.classList.add('highlighted');

    document.querySelectorAll(`.graph-for-sector-${targetSectorId}`).forEach(card => {
        card.classList.add('highlighted-graph');
        card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
}